import React, {Component} from 'react';


class NoMatch extends Component{
    render(){
        return (
            <div>
                not found
            </div>
        )
    }
}
export default NoMatch